import { useContext } from "react";
import GlobalConfigContext from "../Contexts/GlobalConfigContext";

export const useGlobalConfig = () => useContext(GlobalConfigContext);
